<template>
    <div>
        <CFooter :fixed="false" class="d-lg-none bg-900 text-50">
            <div class="mfs-auto mr-1">
                &copy; {{new Date().getFullYear()}} by Thomas Behn
            </div>
        </CFooter>
        <CFooter :fixed="false" class="d-md-down-none">
            <div class="ml-3">
                <strong>HVV Sabbenhausen</strong> - Dorfscheune Ahornweg 1 - 32676 Lügde-Sabbenhausen
            </div>
            <div class="mfs-auto mr-1">
                &copy; {{new Date().getFullYear()}} by Thomas Behn
            </div>
        </CFooter>
    </div>
</template>


<script>
    export default {
        name: 'HvvFooter',
    }
</script>